(() => {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 749px)');
  let lastPanel;
  let scrollShell;
  let transparentHeader;

  const updateHeaderMode = () => {
    if (!mobile.matches || !scrollShell || !transparentHeader) return;
    transparentHeader.classList.toggle('pageheader--transparent', scrollShell.scrollTop <= 2);
  };

  const updateFooterMode = () => {
    if (!lastPanel) return;

    const inset = parseFloat(getComputedStyle(root).getPropertyValue('--study-header')) || 88;
    const top = lastPanel.getBoundingClientRect().top;
    const footerIsFree = root.classList.contains('study-footer-free');

    if (!footerIsFree && top <= inset + 2) {
      root.classList.add('study-footer-free');
    } else if (footerIsFree && top > inset + 40) {
      root.classList.remove('study-footer-free');
    }
  };

  const updateScrollState = () => {
    updateHeaderMode();
    updateFooterMode();
  };

  const enableMobileScroller = () => {
    if (scrollShell) return;

    const content = document.querySelector('#content');
    const footer = document.querySelector('#pagefooter');
    if (!content || !footer) return;

    scrollShell = document.createElement('div');
    scrollShell.className = 'study-scroll-shell';
    content.before(scrollShell);
    scrollShell.append(content, footer);
    scrollShell.addEventListener('scroll', updateScrollState, { passive: true });
    root.classList.add('study-mobile-scroll');
    updateHeaderMode();
  };

  const disableMobileScroller = () => {
    if (!scrollShell) return;

    const content = scrollShell.querySelector('#content');
    const footer = scrollShell.querySelector('#pagefooter');
    scrollShell.removeEventListener('scroll', updateScrollState);

    if (content) scrollShell.before(content);
    if (content && footer) content.after(footer);
    scrollShell.remove();
    scrollShell = null;
    root.classList.remove('study-mobile-scroll');
    if (transparentHeader) {
      transparentHeader.classList.toggle('pageheader--transparent', window.scrollY <= 2);
    }
  };

  const configureScroller = () => {
    if (mobile.matches) enableMobileScroller();
    else disableMobileScroller();
    updateScrollState();
  };

  const init = () => {
    const panels = document.querySelectorAll('main .image-design-container>[class*="img-container"]');
    lastPanel = panels[panels.length - 1];
    transparentHeader = document.querySelector('.pageheader--transparent-permitted');
    configureScroller();
  };

  addEventListener('scroll', updateScrollState, { passive: true });
  addEventListener('resize', updateScrollState);
  if (mobile.addEventListener) mobile.addEventListener('change', configureScroller);
  else mobile.addListener(configureScroller);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
